import React from 'react';
import QuizAliasAuth from './QuizAliasAuth';
import QuizPasscodeAuth from './QuizPasscodeAuth';

export default function QuizAuth(props) {
  switch(props.authType)
  {
    default:
    case "Passcode":
      return <QuizPasscodeAuth {...props}></QuizPasscodeAuth>;
    case "Alias":
      return <QuizAliasAuth {...props}></QuizAliasAuth>;
  }
}